import { PayloadAction } from "@reduxjs/toolkit";
import { Visiable } from "../../../../common/models/Visiable";
import { GroupsState } from "../models/GroupsState";

const createClientFormVisiable = (state: GroupsState, action: PayloadAction<Visiable>) => {
    const { visiable } = action.payload;
    state.createClientFormVisiable = visiable;
}

export default createClientFormVisiable;